module.exports = __webpack_public_path__ + "img/syringe.8e6f7d97.svg";